module.exports = __webpack_public_path__ + "img/pb_gallery_3.10b82db0.jpg";